import React from 'react';
import ShimmerEffect from './ShimmerEffect';

const TutorDetailSkeleton: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50">

      {/* Hero Banner Skeleton */}
      <div className="bg-gradient-to-br from-primary-50 via-hero-bg to-white border-b border-gray-100">
        <div className="container mx-auto px-4 sm:px-6 py-6 sm:py-10">
          <ShimmerEffect>
            <div className="h-5 w-28 bg-gray-200 rounded-full mb-6" />
            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-5 sm:gap-8">
              <div className="w-24 h-24 sm:w-28 sm:h-28 rounded-2xl bg-gray-200 flex-shrink-0" />
              <div className="flex-grow w-full">
                <div className="h-8 w-52 bg-gray-200 rounded-lg mb-2" />
                <div className="h-4 w-24 bg-gray-200 rounded-full mb-3" />
                <div className="h-6 w-36 bg-gray-200 rounded-full mb-4" />
                <div className="flex flex-wrap gap-4">
                  <div className="h-4 w-24 bg-gray-200 rounded" />
                  <div className="h-4 w-28 bg-gray-200 rounded" />
                  <div className="h-4 w-32 bg-gray-200 rounded" />
                </div>
              </div>
            </div>
          </ShimmerEffect>
        </div>
      </div>

      {/* Body */}
      <div className="container mx-auto px-4 sm:px-6 py-6 sm:py-8">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 lg:gap-8">

          {/* Left Column */}
          <div className="lg:col-span-2 space-y-5">
            {[...Array(5)].map((_, i) => (
              <ShimmerEffect key={i}>
                <div className="bg-white rounded-2xl border border-gray-100 shadow-sm p-5 sm:p-6">
                  <div className="flex items-center gap-2.5 mb-4">
                    <div className="w-8 h-8 rounded-lg bg-gray-200" />
                    <div className="h-5 w-36 bg-gray-200 rounded" />
                  </div>
                  <div className="space-y-2">
                    <div className="h-4 w-full bg-gray-200 rounded" />
                    <div className="h-4 w-4/5 bg-gray-200 rounded" />
                    <div className="h-4 w-2/3 bg-gray-200 rounded" />
                  </div>
                </div>
              </ShimmerEffect>
            ))}
          </div>

          {/* Right Sidebar */}
          <div className="lg:col-span-1 space-y-4">
            <ShimmerEffect>
              <div className="bg-white rounded-2xl border border-gray-100 shadow-sm overflow-hidden">
                <div className="h-16 bg-gray-200" />
                <div className="grid grid-cols-2 gap-px bg-gray-100 border-b border-gray-100">
                  {[...Array(4)].map((_, i) => (
                    <div key={i} className="bg-white px-4 py-3 flex flex-col items-center gap-1">
                      <div className="h-6 w-16 bg-gray-200 rounded" />
                      <div className="h-3 w-12 bg-gray-200 rounded" />
                    </div>
                  ))}
                </div>
                <div className="p-4">
                  <div className="h-11 w-full bg-gray-200 rounded-xl" />
                </div>
              </div>
            </ShimmerEffect>
            <ShimmerEffect>
              <div className="bg-white rounded-2xl border border-gray-100 shadow-sm p-4 space-y-3">
                <div className="h-3 w-20 bg-gray-200 rounded" />
                {[...Array(3)].map((_, i) => (
                  <div key={i} className="flex items-center gap-2.5">
                    <div className="w-4 h-4 bg-gray-200 rounded flex-shrink-0" />
                    <div className="h-4 bg-gray-200 rounded w-3/4" />
                  </div>
                ))}
              </div>
            </ShimmerEffect>
            <ShimmerEffect>
              <div className="rounded-2xl border border-gray-200 bg-gray-50 p-4 flex items-start gap-3">
                <div className="w-5 h-5 bg-gray-200 rounded flex-shrink-0" />
                <div className="flex-1 space-y-2">
                  <div className="h-4 w-24 bg-gray-200 rounded" />
                  <div className="h-3 w-40 bg-gray-200 rounded" />
                </div>
              </div>
            </ShimmerEffect>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TutorDetailSkeleton;
